"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMergedRef = require("@cbhq/cds-common/hooks/useMergedRef");
var _useScale = require("@cbhq/cds-common/scale/useScale");
var _interactableHeight = require("@cbhq/cds-common/tokens/interactableHeight");
var _Box = require("../layout/Box");
var _tokens = require("../tokens");
var _InputIcon = require("./InputIcon");
var _InputIconButton = require("./InputIconButton");
var _TextInput = require("./TextInput");
const _excluded = ["onChange", "onClear", "onChangeText", "onSearch", "testID", "value", "compact", "hideStartIcon"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const SearchInput = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function SearchInput(_ref, ref) {
  let onChange = _ref.onChange,
    onClear = _ref.onClear,
    onChangeText = _ref.onChangeText,
    onSearch = _ref.onSearch,
    testID = _ref.testID,
    value = _ref.value,
    compact = _ref.compact,
    _ref$hideStartIcon = _ref.hideStartIcon,
    hideStartIcon = _ref$hideStartIcon === void 0 ? false : _ref$hideStartIcon,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const scale = (0, _useScale.useScale)();
  const heightWithoutBorder = _interactableHeight.interactableHeight[scale][compact ? 'compact' : 'regular'];
  const height = `calc(${heightWithoutBorder}px + ${_tokens.borderWidth.input} + ${_tokens.borderWidth.input})`;
  const internalRef = (0, _react.useRef)(null);
  const refs = (0, _useMergedRef.useMergedRef)(ref, internalRef);
  const handleOnChange = (0, _react.useCallback)(e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(e.target.value);
  }, [onChange, onChangeText]);
  const handleOnKeyUp = (0, _react.useCallback)(event => {
    if (event.key === 'Enter') {
      var _value$toString;
      onSearch === null || onSearch === void 0 ? void 0 : onSearch((_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : '');
    }
  }, [onSearch, value]);
  const handleOnClear = (0, _react.useCallback)(e => {
    var _internalRef$current;
    onClear === null || onClear === void 0 ? void 0 : onClear(e);
    (_internalRef$current = internalRef.current) === null || _internalRef$current === void 0 ? void 0 : _internalRef$current.focus();
    onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText('');
    onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
  }, [onClear, onChangeText, onSearch]);
  const boxStyle = (0, _react.useMemo)(() => {
    return compact ? {
      transform: 'scale(0.75)'
    } : undefined;
  }, [compact]);
  return /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, _extends({
    ref: refs,
    borderRadius: "roundedFull",
    end: !!value && /*#__PURE__*/_react.default.createElement(_Box.Box, {
      offsetEnd: compact ? 0.5 : 0,
      spacingEnd: compact ? 0 : 0.5,
      style: boxStyle
    }, /*#__PURE__*/_react.default.createElement(_InputIconButton.InputIconButton, {
      accessibilityLabel: "Clear search query",
      name: "close",
      onPress: handleOnClear,
      testID: testID && `${testID}-close-iconbtn`
    })),
    height: height,
    onChange: handleOnChange,
    onKeyUp: handleOnKeyUp,
    role: "searchbox",
    start: !hideStartIcon && /*#__PURE__*/_react.default.createElement(_InputIcon.InputIcon, {
      name: "search",
      testID: testID && `${testID}-search-icon`
    }),
    testID: testID,
    type: "search",
    value: value,
    variant: "secondary"
  }, props));
}));
exports.SearchInput = SearchInput;